// @ts-strict-ignore
import * as React from 'react';

import {FilterValueProps} from 'common/query-builder/query-entry-section/row-types/filter/types';
// eslint-disable-next-line import/no-cycle
import {QueryEntrySectionReact} from 'common/query-builder/query-entry-section';
import {
  EntrySectionUpdates,
  QueryFilterEntry,
  RowLabelType,
  SelectorTypeDefinitions,
} from 'common/query-builder/query-entry-section/types';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {PropertyType} from 'common/report/constants';
import {isComputedListPropertyFilter} from 'common/widgets/property-filter-menu/utils';

export function FilterListObjectValue(props: FilterValueProps) {
  const entries: QueryFilterEntry[] = (props.filter.listItemFilters || []).map((entry) => ({
    event: entry,
    type: SelectorTypeDefinitions.Filter,
    filters: [],
  }));

  const emptyPlaceholder: QueryFilterEntry = {
    event: {},
    type: SelectorTypeDefinitions.Filter,
    filters: [],
  };

  const handleUpdate = ({entries: updatedEntries}: EntrySectionUpdates<QueryFilterEntry>) => {
    let filters = updatedEntries.map((entry) => new PropertyFilter(entry.event));

    // when selecting a computed property, we want to replace all other existing filters
    const computedFilter = filters.find((filter) => isComputedListPropertyFilter(filter));
    if (computedFilter) {
      filters = [computedFilter];
    }

    props.updateEntry(props.filter.setAttribute(`listItemFilters`, filters));
  };

  return (
    <div className='mp-filter-parts-list-objects'>
      <QueryEntrySectionReact
        elref='listOfObjectsFilterSection'
        dataGroupId={props.dataGroupId}
        entries={entries}
        projectId={props.projectId}
        workspaceId={props.workspaceId}
        userId={props.userId}
        eventNames={props.eventNames}
        readonly={props.readonly}
        rowTypes={[SelectorTypeDefinitions.Filter]}
        rowDraggable={false}
        rowDropDisabled
        rowLabelType={RowLabelType.None}
        emptyPlaceholder={emptyPlaceholder}
        disableAddEntry
        disableMapToLookupTable
        listProperty={props.filter}
        rowActions={props.rowActions}
        disabledTypecastTypes={[PropertyType.List, PropertyType.Object]}
        stagingRow={!entries.length || props.hasPlaceholder || props.isActive}
        onUpdate={handleUpdate}
        onAbortStage={() => props.setActiveEntry(`close`)}
      />
    </div>
  );
}
